import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import BoltIcon from '@flipster/react/icon/generated/BoltIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, vstack } from '@flipster/styled-system/patterns';
import { numberFormatter } from '@flipster/utils/num';

import { RewardImage } from '../_misc/RewardImage';
import { winnerAnnouncementBunja } from './bunja';

export interface WinnerAnnouncementProps {
  showGuideMessage?: boolean;
}

const WinnerAnnouncement = ({ showGuideMessage }: WinnerAnnouncementProps) => {
  const { rewardAtom, bidInfoAtom, imageUrlAtom } = useBunja(winnerAnnouncementBunja);
  const reward = useAtomValue(rewardAtom);
  const { highestBidder: winner, me } = useAtomValue(bidInfoAtom);
  const imageUrl = useAtomValue(imageUrlAtom);
  const winnerIsNotMe = winner && !winner.isMe;
  const showMyFinalBid = me.amount > 0 && winnerIsNotMe;
  if (!winner) return null;
  return (
    <div className={vstack({ w: '100%', gap: 8, textStyle: 'Text/M/Regular' })}>
      <p>The live auction is over. Final results are below.</p>
      <div
        className={vstack({
          w: { base: '100%', tablet: 520 },
          gap: 16,
          p: { base: 16, tablet: 24 },
          borderRadius: 8,
          bg: 'background.default.level-2',
        })}
      >
        <p className={css({ textStyle: 'Title/XS', textAlign: 'center' })}>
          Congratulations <br />
          to the {reward} winner
        </p>
        <div className={vstack()}>
          <span className={hstack({ gap: 4, textStyle: 'Title/L' })}>
            <BoltIcon size={24} />
            <span>{numberFormatter(winner.amount)}</span>
          </span>
          <span className={css({ textStyle: 'Text/S/Strong' })}>{winner.nickname}</span>
        </div>
        <RewardImage imageUrl={imageUrl} />
        {showGuideMessage && (
          <p className={css({ color: 'content.default.level-2' })}>Check T&C announcement for the reward timeline</p>
        )}
      </div>
      {showMyFinalBid && (
        <div
          className={vstack({
            w: { base: '100%', tablet: 520 },
            p: { base: 16, tablet: 24 },
            borderRadius: 8,
            bg: 'background.default.level-3',
          })}
        >
          <span className={css({ textStyle: 'Text/L/Strong' })}>Your final bid</span>
          <span className={hstack({ mt: 8, gap: 4, textStyle: 'Title/L' })}>
            <BoltIcon size={16} />
            <span>{numberFormatter(me.amount)}</span>
          </span>
          <span className={css({ mt: 2, textStyle: 'Text/S/Strong' })}>{me.nickname}</span>
        </div>
      )}
    </div>
  );
};

export default WinnerAnnouncement;
